import { apiClient } from './client';
import { ENDPOINTS } from '../constants/api';

export const categoriesAPI = {
  getCategories: async () => {
    const response = await apiClient.get(ENDPOINTS.CATEGORIES.LIST);
    return response.data.categories || response.data;
  },
};
